import type { McpServer } from '@modelcontextprotocol/sdk/server/mcp.js';
import { getPublicCollectionBySlugV3Api } from '@repo/sdk';
import { z } from 'zod';

export function registerGetCollection(server: McpServer): void {
  server.registerTool(
    'get_collection',
    {
      title: 'Get a Cool Mate collection by slug',
      description:
        'Fetch full public details of one collection (title, description, poster, challenge count) by its slug.',
      inputSchema: { slug: z.string().min(1).max(200) },
    },
    async ({ slug }) => {
      const { data } = await getPublicCollectionBySlugV3Api(slug);
      return {
        content: [{ type: 'text', text: JSON.stringify(data?.data ?? null) }],
      };
    },
  );
}
